module.exports = __webpack_public_path__ + "img/contratos.05ca7788.svg";